import { ImageOff } from 'lucide-react';
import type { EventAttachment } from './event-attachments';
import { useAttachmentUrl } from './use-attachment-url';

interface AttachmentImageButtonProps {
  caseId: string;
  attachment: EventAttachment;
  onOpen: () => void;
}

/** Stor miniatyr for et bildevedlegg. Klikk åpner visning. */
export function AttachmentImageButton({ caseId, attachment, onOpen }: AttachmentImageButtonProps) {
  const { url, isError } = useAttachmentUrl({
    caseId,
    sourceItemId: attachment.sourceItemId,
    enabled: true,
    disposition: 'inline',
  });
  const canOpen = Boolean(attachment.sourceItemId);

  return (
    <button
      type="button"
      title={attachment.fileName ?? 'Bilde'}
      onClick={canOpen ? onOpen : undefined}
      disabled={!canOpen}
      className="relative h-24 w-24 shrink-0 overflow-hidden rounded-md border border-white/10
                 bg-white/5 transition hover:border-white/25 disabled:opacity-60"
    >
      {url && !isError ? (
        <img
          src={url}
          alt={attachment.fileName ?? ''}
          loading="lazy"
          className="h-full w-full object-cover"
        />
      ) : (
        <span className="flex h-full w-full items-center justify-center text-text-tertiary">
          {isError ? <ImageOff size={20} /> : <span className="text-[10px]">Laster…</span>}
        </span>
      )}
    </button>
  );
}
